import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../../components/layouts/dashboardLayout";
import { BASE_URL } from "../../config/endPoint";
import { httpGet, httpDelete } from "../../utils/api";
import Loader from "../../components/loader/loader";
import { toast } from "react-toastify";

function CategoryBrands() {
  const { categoryId } = useParams();
  const [brands, setBrands] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const navigate = useNavigate();

  const getBrands = async () => {
    try {
      const res = await httpGet(`${BASE_URL}/brand/list`);

      if (res?.data?.status) {
        const filtered = res.data.response.filter(
          (b) => b?.cateId?._id === categoryId
        );
        setBrands(filtered);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getBrands();
  }, [categoryId]);

  const deleteBrand = async () => {
    setIsDeleting(true);
    try {
      const res = await httpDelete(`${BASE_URL}/brand/${deleteId}`);
      if (res?.data?.status) {
        toast.success("Brand deleted");
        getBrands();
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsDeleting(false);
      setDeleteId("");
    }
  };

  const columns = [
    {
      name: <b>Brand Name</b>,
      selector: (row) => row.brandName,
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => navigate(`/editBrand/${row._id}`)}
            style={{ border: "none", background: "transparent" }}
          >
            <i className="fa-solid fa-pen" style={{ color: "blue" }}></i>
          </button>

          <button
            onClick={() => setDeleteId(row._id)}
            style={{ border: "none", background: "transparent" }}
          >
            <i className="fas fa-trash" style={{ color: "red" }}></i>
          </button>
        </div>
      ),
    },
  ];

  return (
  <DashboardLayout>
    <div className="table-outer">

      {/* Back + Title Row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "15px",
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            border: "none",
            background: "transparent",
            fontSize: "18px",
            cursor: "pointer",
          }}
        >
          <i className="fa-solid fa-arrow-left"></i>
        </button>

        <h4 style={{ margin: 0 }}>
            {brands[0]?.cateId?.name || "Category"} Brands
        </h4>
      </div>

      <DataTable
        columns={columns}
        data={brands}
        pagination
        progressPending={isLoading}
        highlightOnHover
      />

      {isDeleting && <Loader />}
    </div>
  </DashboardLayout>
);

}

export default CategoryBrands;
